import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'
import MobileCtaBar from '@/components/generals/mobile-cta-bar'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only z-[60] rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main-content' className='flex-1'>
                {children}
            </main>

            <SiteFooter />

            <MobileCtaBar />
        </div>
    )
}
